import apiService from '../apiService';

const recordTypeService = {
  // ---- Matter create/edit form ----

  // Active record types for the "new matter" picker.
  async getActiveRecordTypes() {
    try {
      const response = await apiService.get(`/record-types`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // Sections + fields for a record type (matter form rendering).
  async getRecordTypeLayout(id) {
    try {
      const response = await apiService.get(`/record-types/${id}/layout`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // ---- Settings (admin) ----

  async getAll() {
    try {
      const response = await apiService.get(`/settings/record-types`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getOne(id) {
    try {
      const response = await apiService.get(`/settings/record-types/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async create(payload) {
    try {
      const response = await apiService.post(`/settings/record-types`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async update(payload, id) {
    try {
      const response = await apiService.put(`/settings/record-types/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async remove(id) {
    try {
      const response = await apiService.delete(`/settings/record-types/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async saveLayout(id, payload) {
    try {
      const response = await apiService.put(`/settings/record-types/${id}/layout`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // ---- Stages (admin, OL-208) ----

  async getStages(id) {
    try {
      const response = await apiService.get(`/settings/record-types/${id}/stages`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async createStage(id, payload) {
    try {
      const response = await apiService.post(`/settings/record-types/${id}/stages`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateStage(id, stageId, payload) {
    try {
      const response = await apiService.put(`/settings/record-types/${id}/stages/${stageId}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async reorderStages(id, order) {
    try {
      const response = await apiService.put(`/settings/record-types/${id}/stages/reorder`, { order });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteStage(id, stageId) {
    try {
      const response = await apiService.delete(`/settings/record-types/${id}/stages/${stageId}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default recordTypeService;
